import React from 'react';

import {
	ReportingLinesUserCard,
	type ReportingLinesUserCardProps,
} from '../ReportingLinesUserCard';
import * as Styled from '../styles';
import { type ReportingLinesUser } from '../types';

export const renderReportingLinesUserCard = (user: ReportingLinesUser, testId?: string) => {
	return (
		<ReportingLinesUserCard
			user={user}
			// this testid helps to query all different profile-cards and verify its order easily in test.
			testId={`profile-card${testId ? `-${testId}` : ''}`}
		/>
	);
};

export const ReportingLinesUserCardWithLine = (props: ReportingLinesUserCardProps) => {
	return (
		<>
			<ReportingLinesUserCard
				{...props}
				// this testid helps to query all different profile-cards and verify its order easily in test.
				testId={`profile-card${props.testId ? `-${props.testId}` : ''}`}
			/>
			<Styled.VerticalChartLine />
		</>
	);
};
